import LandingPage from '@/views/landing';
import * as React from 'react';
export default {
  LandingPage,
  React
};